const TAXI_UPDATED = (state, Taxi) => {
  state.Taxi = Taxi
}

const TAXI_VOUCHER_UPDATED = (state, Voucher) => {
  state.Voucher = Voucher
}

const TAXI_COMPANIES_UPDATED = (state, taxiCompanies) => {
  state.taxiCompanies = taxiCompanies
}

export default {
  TAXI_UPDATED,
  TAXI_VOUCHER_UPDATED,
  TAXI_COMPANIES_UPDATED
}
